import { useEffect, useState } from 'react';

/**
 * Cycles through the panels on a fixed interval for unattended beamer use.
 *
 * Pauses while `paused` is true (e.g. during a walk-on overlay) so the rotation
 * does not advance behind the entrance animation.
 */
export function useRotatingPanel(count: number, intervalMs: number, paused: boolean): number {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (paused || count <= 1) {
      return;
    }

    const timer = window.setInterval(() => {
      setIndex((value) => (value + 1) % count);
    }, intervalMs);

    return () => {
      window.clearInterval(timer);
    };
  }, [count, intervalMs, paused]);

  return Math.min(index, Math.max(0, count - 1));
}
